import Stack from 'components/atoms/stack/Stack'

const VStack = ({ children, ...props }) => {
	
	return (
		<Stack
			direction="column"
			{ ...props }>
			
			{ children }
		</Stack>
	)
}

export default VStack;
